'use strict';

module.exports = {
    endpointEventTypes: require('./endpointEventTypes'),
    jetDeliveryEventTypes: require('./jetDeliveryEventTypes'),
    jetJobEventTypes: require('./jetJobEventTypes'),
    jetTransferEventTypes: require('./jetTransferEventTypes'),
    storageProfileEventTypes: require('./storageProfileEventTypes'),
    subscriptionEventTypes: require('./subscriptionEventTypes')
};